import React from 'react';
import { Card } from '../../../../components/display/Card';
import { Icon } from '../../../../components/base/Icon';
import { ValueMappingTable } from '../../value-mapping/ValueMappingTable';
import { FieldConfiguration, DisplayStyle } from '../../../types';
import { faWandMagicSparkles } from '@fortawesome/pro-solid-svg-icons';
import { useThemeColors } from '../../../../providers/ThemeProvider';
import { cn } from '../../../../utils/cn';
import { Text } from '../../../../components/base/Text';

interface ValueMappingConfiguratorProps {
  field: FieldConfiguration;
  onUpdateField: (updates: Partial<FieldConfiguration>) => void;
  isModalOpen?: boolean;
}

export function ValueMappingConfigurator({
  field,
  onUpdateField,
  isModalOpen = false
}: ValueMappingConfiguratorProps) {
  const colors = useThemeColors();
  return (
    <Card className="mb-4">
      <div className="p-4">
        <div className="flex items-center mb-3">
          <Icon icon={faWandMagicSparkles} size="sm" color={colors.values.textPrimary} className="mr-2" />
          <Text className="text-base font-semibold">
            Value Mapping
          </Text>
        </div>

        <Text className="text-xs mb-3" color="secondary">
          Map values to display text or icons and optionally apply colors. This allows you to transform database values like "credit_card", "check", "cash" into meaningful text or icons.
        </Text>

        <ValueMappingTable
          mappings={field.styleConfig.valueMapping || []}
          onChange={(mappings) => {
            onUpdateField({
              styleConfig: {
                ...field.styleConfig,
                valueMapping: mappings
              }
            });
          }}
          isModalOpen={isModalOpen}
          displayStyle={field.displayStyle}
        />
      </div>
    </Card>
  );
}